import noop from 'lodash/noop';
import { createContext } from 'react';

const NowPlayingContext = createContext({ scrollToTop: noop });

export default NowPlayingContext;
